module.exports = "/static/images/H--white.svg";